import PropertyCreate from "./PropertyCreate";

export default PropertyCreate;
